import validatePostalCode from '../basket/js/validators/postalCodeValidator';

var currentIndex = 0;
let maxIndex = 2;
const DELIVERY_TYPE_UPS = 'ups';

const Step1Validator = function (OrderIssue) {

    this.orderIssue = OrderIssue;
    this.errors = 0;
    this.validationErrors = {
        '#orderresize-item-product_code' : [],
        '#orderresize-item-size' : [],
        '#aups-phoneNumber' : [],
        '#aups-email' : [],
        '#aups-fullName' : []
    };

    this.setIssueDate = function (data) {
        this.orderIssue = data;
    };

    this.setProductValidationErrors = function (errorMessage) {

        let error = 'Nie odnaleziono produktu';
        this.validationErrors['#orderresize-item-product_code'] = [];


        if(error) {
            this.validationErrors['#orderresize-item-product_code'].push(error);

            let field = new Field('#orderresize-item-product_code');
            field.addError(error);
        }

    };

    this.validateProductData = function () {
        let errors = 0;

        this.validationErrors['#orderresize-item-product_code'] = [];

        let field = $('#orderresize-item-product_code').val();

        if(field.trim().length == 0) {
            this.validationErrors['#orderresize-item-product_code'].push('Pole nie może być puste');
            errors++;
        }

        else if(this.orderIssue.storehouseProduct.id === undefined || this.orderIssue.storehouseProduct.id === null) {
            this.validationErrors['#orderresize-item-product_code'].push('Nieprawidłowy numer produktu');
            errors++;
        }

        this.errors += errors;
    };

    this.isProperName = function () {
        this.validationErrors['#aups-fullName'] = [];
        let value = $('#aups-fullName').val().trim();

        let data = value.split(/(\s+)/).filter( e => e.trim().length > 0);

        if(data.length != 2) {
            this.validationErrors['#aups-fullName'].push('Należy podać imię i nazwisko');
            this.errors ++
        }
    };

    this.isEmail = function () {
        this.validationErrors['#aups-email'] = [] ;

        let value = $('#aups-email').val();

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) == false) {
            this.validationErrors['#aups-email'].push('Należy podać prawidłowy adres e-mail');
            this.errors++;
        }
    };
    
    this.validatePhone = function () {
        let value = $('#aups-phoneNumber').val().trim();
        this.validationErrors['#aups-phoneNumber'] = [];

        if(value.length == 0) {
            this.validationErrors['#aups-phoneNumber'].push('Nie może być puste');
            this.errors++;
        }
    };

    this.validateSize = function() {
        this.validationErrors['#orderresize-item-size'] = [];

        let productErrors = this.validationErrors['#orderresize-item-product_code'].length > 0;

        if(productErrors) {
            return ;
        }

        if($('#orderresize-item-size').val().length == 0) {
            this.validationErrors['#orderresize-item-size'].push('Nie może być puste');
            this.errors++;
        }

        if(isNaN($('#orderresize-item-size').val())) {
            this.validationErrors['#orderresize-item-size'].push('Rozmiar musi być liczbą');
            this.errors++;
        }

        let size = parseFloat($('#orderresize-item-size').val());

        if((size >= 7 && size <= 22) === false) {
            this.validationErrors['#orderresize-item-size'].push('Dostępne rozmiary pomiędzy 7 a 22');
            this.errors++;
        }

    };

    this.validateCommentField = function () {
        this.validationErrors['#orderresize-item-komentarz'] = [];

        if($('#orderresize-item-komentarz').val().length == 0) {
            this.validationErrors['#orderresize-item-komentarz'] = ['Nie może być puste'];
            this.errors++;
        }
    };

    this.validate = function () {
        this.errors = 0;

        this.validateProductData();
        this.validateSize();
        this.isEmail();
        this.validatePhone();
        this.isProperName();

        let errors = Object.entries(this.validationErrors);

        errors.map( (entry, index) => {
            let field = new Field(entry[0]);
            if(entry[1].length > 0) {
                field.addError(entry[1]);

                if(index == 0) {
                    field.focus();
                }

            }
            else {
                field.removeError()
            }

        });

    };

    this.isValid = function () {
        return this.errors == 0;
    };

};

const Step2Validator = function (OrderIssue) {
    this.orderIssue = OrderIssue;

    this.enabled = true;

    this.validationErrors = {
        '#aups-number' : ['isNull'],
        '#aups-city' : ['isNull'],
        '#aups-postalCode' : ['isPostalCode'],
    };

    this.errors = 0;

    this.isNull = function (name, value) {
        value = value.trim();

        if(value === null || value === '') {
            return `nie może być puste`
        }
    };

    this.checkIfDesitionWasMade = function() {
        let links = $('#delivery-choice-container').find('a');
        let isSelected = false;
        links.each(function () {
            if($(this).hasClass('active-position')) {
                isSelected = true;
            }
        });

        if(isSelected) {
            $('#dispatch-choice-error').addClass('hidden');
        }
        else {
            $('#dispatch-choice-error').removeClass('hidden');
        }

        return isSelected;

    };

    this.isEmail = function (name, value) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) == false) {
            return `Należy podać prawidłowy adres e-mail`;
        }
    };

    this.isPostalCode = function (name, value) {
        if ($('#country-select').val() == 'IE') {
            return true;
        }

        return this.isNull(name,value);

        if (validatePostalCode(value,$('#country-select').val()) == false)  {
            return 'Należy podać prawidłowy kod pocztowy';
        }
    };


    this.validateField = function(name,value) {
        if (!(`#${name}` in this.validationErrors)) {
            return;
        }

        return this.validationErrors[`#${name}`].map(validator => {
            let result = this[validator](name,value);
            if(result !== undefined)
                return result;
        }).filter(error => {
            if(error !== undefined) {
                return error;
            }
        })

    };

    this.validate = function () {
        $('#fieldset-address input').filter('[required]:visible').each(inputChangedEvent);

    };

    this.isValid = function () {
        if (this.checkIfDesitionWasMade() == false) {
            return false;
        }

        if(!this.enabled) {
            return true;
        }

        return $('#fieldset-address').filter(':visible').find('.is-invalid').length === 0
    };
};

const Field = function (selector) {
    this.selector = $(selector);

    this.value = $(selector).val();

    this.hasError = false;

    this.errorTemplate = function (error) {
        return `<div class="invalid-feedback">${error}</div>`;
    };

    this.clearErrors = function () {
        this.selector.parent().find('.invalid-feedback').remove();
    };

    this.addError = function (error) {
        this.removeError();
        this.selector.addClass('is-invalid');
        this.selector.parent().append(this.errorTemplate(error));
        this.hasError = true;
    };

    this.removeError = function () {
        this.clearErrors();
        this.selector.removeClass('is-invalid');
        this.hasError = false;
    };

    this.focus = function()  {
        this.selector.focus();
    }
};


const orderIssue = {
    comment : null,
    storehouseProduct : {
        id : null
    },
    item : {
        productCode : null,
        contact : {
            name : '',
            email : '',
            tel : ''
        }
    },
    dispatch: {
        toAclari : {
            fullName : '',
            phoneNumber : '',
            street : '',
            city : '',
            postalCode : ''
        },
        fromAclari : {
            type : '',
            name : '',
            phone : '',
            street : '',
            city : '',
            postalCode : ''
        }
    }
};

const step1Validator = new Step1Validator(orderIssue);
const step2Validator = new Step2Validator(orderIssue);

var ProductCodeComponent = function(selector, onSuccess, onFailure) {
    this.selector = $(selector);
    this.isValid = false;

    this.value = this.selector.val();

    this.timeoutId = null;

    this.selector.keyup(function () {
        let value = $(this).val();

        clearTimeout(this.timeoutId);

        if(value.length >= 7) {
            this.timeoutId = setTimeout(function () {
                $.ajax({
                    global: false,
                    url: '/main/order/get-product',
                    data: {
                        code: value,
                        type : 'resize'
                    },
                    success: response => onSuccess(response),
                    error: response => onFailure(response)
                })
            }, 100);
        }

    });
};

let component = new ProductCodeComponent('#orderresize-item-product_code', function (response) {
    orderIssue.storehouseProduct = response;
    step1Validator.validationErrors['#orderresize-item-product_code'] = [];

    step1Validator.setIssueDate(orderIssue);

    let field = new Field('#orderresize-item-product_code');
    field.removeError();

    const productSizeSelector = $('#orderresize-item-size');
    productSizeSelector.prop('disabled', false);
    productSizeSelector.val($('#orderresize-item-size option:eq(1)').val());

}, function (errorResponse) {
    step1Validator.setProductValidationErrors(errorResponse.responseJSON);

    orderIssue.storehouseProduct = {
        id : null,
        product : {
            name : null
        },
        productCode : null
    };

    step1Validator.setIssueDate(orderIssue);

    const productSizeSelector = $('#orderresize-item-size');
    productSizeSelector.prop('disabled', true);
    productSizeSelector.val($('#orderresize-item-size option:eq(0)').val());
});

$('.multiform-nav__link').click(function () {

    let currentId = $(this).attr('id');

    $('.multiform-nav__item').each(function (index) {
        let a =$(this).find('a');

        if(a.attr('id') == currentId) {
            currentIndex = index
        }
    });

});

var ValidationFactory = function(currentStep) {
    this.currentStep = 0;

    this.validators = [];

    this.addValidator = function(stepNumber, validator) {
        this.validators[stepNumber] = validator;
    };

    this.validate = function () {
        return this.validators[this.currentStep].validate();
    };

    this.isValid = function () {
        return this.validators[this.currentStep].isValid();
    };
};

function inputChangedEvent()
{
    let namespace = $(this).attr('id').split('-');

    let field = new Field(`#${$(this).attr('id')}`);


    let validationResult = step2Validator.validateField($(this).attr('id'), $(this).val());

    if(validationResult.length > 0) {
        field.addError(validationResult)
    }
    else {
        field.removeError();
        orderIssue.dispatch.toAclari[namespace[1]] = $(this).val();
    }
}

const UpsShippingValidator = function() {
    this.ID = 1;

    this.container = $('#fieldset-shipping-method-ups');

    this.errors = 0;

    this.validate = function () {
        this.errors = 0;

        this.container.find('.required').each(function () {
            let input = new Field($(this));

            if($(this).val() == null || $(this).val() == '') {
                input.addError('Nie może być puste');
                this.errors = this.errors + 1;
            }
            else {
                input.removeError();

                if($(this).hasClass('postal-code')) {
                    if(validatePostalCode($(this).val(), $('#country-select2').val()) === false) {
                        input.addError('Proszę podać poprawny kod pocztowy');
                        this.errors = this.errors + 1;
                    }
                }
            }
        });
    };

    this.isValid = function () {
        return this.container.find('.is-invalid').length === 0;
    };

    this.markRequiredFields = function () {
        $('#aups-fullName2').addClass('required');

        $('#aups-postalCode2').addClass('required');
        $('#aups-number2').addClass('required');
        $('#aups-postalCode2').addClass('required');
        $('#aups-city2').addClass('required');
        $('#aups-phone2').addClass('required');
        $('#aups-email2').addClass('required');
    };

    this.unMarkRequiredFields = function () {
        $('#aups-fullName2').removeClass('required');
        (new Field($('#aups-fullName2'))).removeError();

        $('#aups-street2').removeClass('required');
        (new Field($('#aups-street2'))).removeError();

        $('#aups-postalCode2').removeClass('required');
        (new Field($('#aups-postalCode2'))).removeError();

        $('#aups-number2').removeClass('required');
        (new Field($('#aups-number2'))).removeError();

        $('#aups-postalCode2').removeClass('required');
        (new Field($('#aups-postalCode2'))).removeError();

        $('#aups-city2').removeClass('required');
        (new Field($('#aups-city2'))).removeError();

        $('#aups-phone2').removeClass('required');
        (new Field($('#aups-phone2'))).removeError();

        $('#aups-email2').removeClass('required');
        (new Field($('#aups-email2'))).removeError();
    };

    this.isActive = function (id) {
        return id == this.ID;
    };

    this.needsValidation = function(id) {
        if(this.isActive(id))
            this.markRequiredFields();
        else {
            this.unMarkRequiredFields();
        }
    }
};

const PosShippingValidator = function() {
    this.ID = 3;

    this.container = $('#fieldset-shipping-method-local-pickup');

    this.isActive = function (id) {
        return id == ID;
    };

    this.validate = function () {
        this.container.find('.required').each(function () {
            let field = new Field($(this));

            if($(this).val() == '' || $(this).val() == null) {
                field.addError('Nie może być puste')
            }
            else {
                field.removeError();
            }

        });
    };
    this.isValid = function () {
        return this.container.find('.is-invalid').length === 0;

    };

    this.isActive = function (id) {
        return id == this.ID;
    };

    this.markRequiredFields = function () {
        $('#pos_client_pos_id').addClass('required');
    }

    this.unMarkRequiredFields = function () {
        $('#pos_client_name').removeClass('required');
        (new Field($('#pos_client_name'))).removeError();
        $('#pos_client_phone').removeClass('required');
        (new Field($('#pos_client_phone'))).removeError();
        $('#pos_client_pos_id').removeClass('required');
        (new Field($('#pos_client_pos_id'))).removeError();
    };

    this.needsValidation = function(id) {
        if(this.isActive(id))
            this.markRequiredFields();
        else {
            this.unMarkRequiredFields();
        }
    }
};

const InPostShippingValidator = function() {
    this.ID = 2;

    this.container = $('#fieldset-shipping-method-local-inpost');

    this.isActive = function (id) {
        return id == this.ID;
    };

    this.isActive = function (id) {
        return id == this.ID;
    };

    this.fields = [
        $('#fieldset-shipping-method-local-inpost #orderresize-item-inpost-paczkomat_primary')
    ];

    this._isValid = true;

    this.validate = function () {
        this._isValid = true;

        this.getFields().map(field => {
            let _field = new Field(field);

            if(field.hasClass('required')) {
                if(field.val() == '' || field.val() == null) {
                    _field.addError('Nie może być puste');
                    this._isValid = false;
                }
                else{
                    _field.removeError();
                }
            }

        });
    };

    this.getFields = function () {
        return this.fields;
    };

    this.markRequiredFields = function () {
        this.getFields().map(field => {
            field.addClass('required');
        });
    };

    this.unMarkRequiredFields = function () {
        this.getFields().map(field => {
            field.removeClass('required');
            let _field = new Field(field);
            _field.removeError();
        });
    };

    this.isValid = function () {
        return this._isValid;
    };

    this.needsValidation = function(id) {
        if(this.isActive(id))
            this.markRequiredFields();
        else {
            this.unMarkRequiredFields();
        }
    }
};

const ShippingValidatorFactory = function(currentShippingId) {
    this.currentShippingId = currentShippingId;

    this.validators = [new UpsShippingValidator(),new InPostShippingValidator(),new PosShippingValidator()];

    this.getValidator = function () {
        let index = this.currentShippingId - 1;
        return this.validators[index]
    };

    this.errors = 0;
    this.consentErrors = 0;

    this.validate = function () {
        this.errors = 0;

        if (this.getValidator()) {
            this.consentErrors = 0;
            this.getValidator().validate();
        }

        if($('#consent-1').prop('checked') === false)  {
            this.errors += 1;
            this.consentErrors += 1;

            $('#consent-1').parent().css('color', '#ff0000');
        } else {
            $('#consent-1').parent().css('color', '#000');
        }

        if($('#consent-2').prop('checked') === false)  {
            this.errors += 1;
            this.consentErrors += 1;

            $('#consent-2').parent().css('color', '#ff0000');
        } else {
            $('#consent-2').parent().css('color', '#000');
        }
    };

    this.isValid = function () {
        return this.getValidator().isValid() && this.errors === 0;
    }

    this.needsValidation = function(id) {

        if(this.isActive(id))
            this.markRequiredFields();
        else {
            this.unMarkRequiredFields();
        }
    }

    this.disableValidation = function () {
        this.unMarkRequiredFields();
    };

    this.setDeliveryMethod = function (shippingId) {
        this.currentShippingId = shippingId;

        this.validators.map(validator => {
            validator.needsValidation(shippingId);
        });

    };

    this.setDeliveryMethod(currentShippingId);

};

$('#fieldset-address input').change(inputChangedEvent);

const formValidation = new ValidationFactory(currentIndex);
const shippingValidation = new ShippingValidatorFactory(1);
formValidation.addValidator(0,step1Validator);
formValidation.addValidator(1,step2Validator);
formValidation.addValidator(2,shippingValidation);

$('.multiform-prev-next button').click(function () {
    if($(this).attr('rel') == 'prev') {
        if(currentIndex <= 0) {
            if(confirm('Czy chcesz wyjść ?')) {
                window.location = '/';
            }
        }
        else  {
            currentIndex--;
        }

    } else {
        formValidation.currentStep = currentIndex;
        formValidation.validate();

        if(formValidation.isValid()) {
            if(currentIndex < maxIndex) {
                currentIndex++;
            } else if (currentIndex === maxIndex) {
                $('#resizeModalCenter').modal('show');

                $.ajax({
                    data : JSON.stringify({
                        orderresize : {
                            item: {
                                aups_chk : $('#orderresize-item-aups_chk').prop('checked'),
                                product_code : $('#orderresize-item-product_code').val(),
                                size : $('#orderresize-item-size').val(),
                                komentarz: $('#orderresize-item-komentarz').val(),
                                contact_name : $('#aups-fullName').val(),
                                aups_company_name : $('#aups-companyName').val(),
                                aups_ulica : `${$('#aups-street').val()} ${$('#aups-number').val()}`,
                                aups_kod_pocztowy : $('#aups-postalCode').val(),
                                aups_miejscowosc  : $('#aups-city').val(),
                                aups_kraj : {
                                    nazwa: $('#country-select > option:selected').text(),
                                    code: $('#country-select > option:selected').val()
                                },
                                shop_type : 2,
                                contact_tel : $('#aups-phoneNumber').val(),
                                contact_email : $('#aups-email').val(),
                                aups_comment : $('#aups-comment').val(),
                                delivery_type : $('.shipping-method input:checked').val(),
                                ups: {
                                    kraj : {
                                        nazwa: $('#country-select2 > option:selected').text(),
                                        code: $('#country-select2 > option:selected').val()
                                    },
                                    company_name : $('#aups-companyName2').val(),
                                    kod_pocztowy : $('#aups-postalCode2').val(),
                                    miejscowosc : $('#aups-city2').val(),
                                    ulica : `${$('#aups-street2').val()} ${$('#aups-number2').val()}`,
                                    telefon : $('#aups-phoneNumber').val(),
                                    imienazwisko : $('#aups-fullName').val()
                                },
                                pos: {
                                    pos_id : $('#pos_client_pos_id').val(),
                                    telefon : $('#aups-phoneNumber').val(),
                                    imienazwisko : $('#aups-fullName').val()
                                },
                                inpost : {
                                    email : $('#aups-email').val(),
                                    telefon : $('#aups-phoneNumber').val(),
                                    paczkomat_primary : $('#orderresize-item-inpost-primary-name').val(),
                                    primary: {
                                        name : $('#orderresize-item-inpost-primary-name').val(),
                                        postcode: $('#orderresize-item-inpost-primary-postcode').val(),
                                        street: $('#orderresize-item-inpost-primary-street').val(),
                                        buildingnumber : $('#orderresize-item-inpost-primary-buildingnumber').val(),
                                        town: $('#orderresize-item-inpost-primary-town').val(),
                                        latitude : $('#orderresize-item-inpost-primary-latitude').val(),
                                        longitude: $('#orderresize-item-inpost-primary-longitude').val(),
                                        paymentavailable: $('#orderresize-item-inpost-primary-paymentavailable').val(),
                                        operatinghours : $('#orderresize-item-inpost-primary-operatinghours').val(),
                                        locationdescription: $('#orderresize-item-inpost-primary-locationdescription').val(),
                                        paymentpointdescr: $('#orderresize-item-inpost-primary-paymentpointdescr').val(),
                                        paymenttype: $('#orderresize-item-inpost-primary-paymenttype').val()
                                    }
                                }
                            }
                        },
                        summary : {
                            item : {
                                chk_reg: [$('#consent-1').prop('checked') ? 1 : 0],
                                chk_do: [$('#consent-2').prop('checked') ? 1 : 0]
                            }
                        }
                    }),
                    method: 'POST',
                    type : 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function (response) {
                        if(response.data.uid) {

                            $('#resizeModalCenter').find('#modal-body__col_waiting').addClass('hide');
                            $('#resizeModalCenter').find('#modal-body__col_end').removeClass('hide');

                            if(response.links !== undefined) {
                                if( (response.links.payment == undefined || response.links.payment == null) == false ) {
                                    window.location.href = response.links.payment;
                                }
                            }
                        }
                    },
                    error : function (response) {
                        $('#resizeModalCenter').find('#modal-body__col_waiting').addClass('hide');
                        $('#resizeModalCenter').find('#modal-body__col_error').removeClass('hide');
                    }
                })

            }
        }
    }

    $('.nav-tabs a').removeClass('active');
    let link = $('.nav-tabs a').eq(currentIndex);
    link.addClass('active');
    let dest = link.data('target');

    $('.tab-pane').removeClass('show');
    $(dest).addClass('show');

    link.tab('show');

    formValidation.currentStep = currentIndex;
});

$('.shipping-method .custom-radio input').click(function () {
    let shippingMethodId = $(this).val();

    shippingValidation.setDeliveryMethod($(this).val());

    $('.fieldset-shipping-method').each(function() {
        if($(this).data('shippingMethod') != shippingMethodId) {
            $(this).addClass('hide');

        } else {
            $(this).removeClass('hide');
        }
    });

    if (parseInt(shippingMethodId) === 2) {
        const inpostBox = $('.shipping .inpost-box');
        const inpostPoint = $('.shipping .inpost-point');

        if (inpostBox.hasClass('hidden')) {
            inpostBox.removeClass('hidden');
            inpostPoint.addClass('hidden');
        }

        window.easyPackAsyncInit = function () {
            easyPack.init({
                defaultLocale: 'pl',
                mapType: 'osm',
                searchType: 'osm',
                points: {
                    types: ['parcel_locker_only']
                },
                map: {
                    initialTypes: ['parcel_locker_only']
                }
            });

            easyPack.mapWidget('easypack-map', function(point) {
                const modalSelector = $('#easypack-map');

                modalSelector.find('.leaflet-pane.leaflet-popup-pane').html('');
                modalSelector.find('#point-list').find('li > a[href="#' + point.name + '"]').parent().addClass('selectedPoint');

                rewriteInPostPointToForm(point);
            });
        }
    }
});

function rewriteInPostPointToForm(point) {
    if (point) {
        $('#orderresize-item-inpost-paczkomat_primary').val(point.name);

        $('#orderresize-item-inpost-primary-name').val(point.name);
        $('#orderresize-item-inpost-primary-postcode').val(point.address_details.post_code);
        $('#orderresize-item-inpost-primary-street').val(point.address_details.street);
        $('#orderresize-item-inpost-primary-buildingnumber').val(point.address_details.building_number);
        $('#orderresize-item-inpost-primary-town').val(point.address_details.city);
        $('#orderresize-item-inpost-primary-latitude').val(point.location.latitude);
        $('#orderresize-item-inpost-primary-longitude').val(point.location.longitude);
        $('#orderresize-item-inpost-primary-paymentavailable').val(null);
        $('#orderresize-item-inpost-primary-operatinghours').val(point.opening_hours);
        $('#orderresize-item-inpost-primary-locationdescription').val('');
    }
}

$('#fieldset-shipping-method-ups input , #fieldset-shipping-method-ups select').change(function () {
    formValidation.validate();
});

$('#copy-data').click(function() {
    $('#country-select2').val($('#country-select').val());
    $('#aups-companyName2').val($('#aups-companyName').val());
    $('#aups-fullName2').val($('#aups-fullName').val());
    $('#aups-street2').val($('#aups-street').val());
    $('#aups-number2').val($('#aups-number').val());
    $('#aups-postalCode2').val($('#aups-postalCode').val());
    $('#aups-city2').val($('#aups-city').val());

    return false;
});

$('#fieldset-address').hide();
let checkbox = $('#orderresize-item-aups_chk');

$('#country-select').change(function() {
    let isDisabled = $(this).val() != 'PL';

    $('#fieldset-address input, #fieldset-address select, #fieldset-address textarea').attr('disabled', isDisabled);
    $('#country-select').prop('disabled', false);

    if(isDisabled) {
        $('#dispach-error').removeClass('hidden');
    }
    else {
        $('#dispach-error').addClass('hidden');
    }

    step2Validator.enabled = !isDisabled;

});

$('.delivery-choice-container a').click(function () {
    $('.delivery-choice-container a').removeClass('active-position');
    $(this).addClass('active-position');

    $('#dispatch-choice-error').addClass('hidden');

    if($(this).data('delivery-type') == DELIVERY_TYPE_UPS) {
        $('#fieldset-address').show();
        step2Validator.enabled = true;
        checkbox.prop('checked', true);
    }
    else {
        $('#fieldset-address').hide();
        step2Validator.enabled = false;
        checkbox.prop('checked', false);
    }

    return false;
});

$('#aups-fullName').change(function () {
    $('.namesurname').val($(this).val());
});


toggleShowPickupDate();

$('#adl_pickup_date, #adhl-postalCode').on('change', function () {
    if (step2Validator.enabled && $('#adhl-postalCode').val() && $('#adl_pickup_date option:selected').val())  {
        checkDateIsAvailable();
    } else if ($('#adl_pickup_date option').length == 0) {
        toggleShowPickupDate();
    }
})

function toggleShowPickupDate() {
    if (step2Validator.enabled && $('#adhl-postalCode').val()) {
        getPickupDates();

        $('#adl_pickup_date_row').removeClass('hide');
    } else {
        $('#adl_pickup_date_row').addClass('hide');
    }
}

function getPickupDates() {
    $.ajax({
        url: 'order/get-pickup-dates',
        type: 'POST',
        dataType: 'json',
        data: {
            'postal-code': $('#adhl-postalCode').val(),
        },
        success: function (res) {
            $('#adl_pickup_date').empty();
            $.each(res, function (i, item) {
                $('#adl_pickup_date').append($('<option>', {
                    value: item,
                    text : item
                }));
            });
        }
    })
}

function checkDateIsAvailable() {
    $.ajax({
        url: 'order/is-pickup-is-available',
        type: 'POST',
        dataType: 'json',
        data: {
            'postal-code': $('#adhl-postalCode').val(),
            'date': $('#adl_pickup_date option:selected').val(),
        },
        success: function (res) {
            $("#adl_pickup_date option[value='"+ $('#adl_pickup_date option:selected').val(), + "']").attr('disabled', !res);
        }
    })
}
